/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match */

import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { SchemaField, Document, DocumentSchema, SystemFieldType } from '../../../store/models/document.model';
import { DynamicField } from '../dynamic-field';
import { ViewComponent } from '../../../store/models/workflow.model';
import { DocumentReader } from '../../../store/models';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';

@Component({
    selector: 'app-color-field',
    templateUrl: './color-field.component.html',
    styleUrls: ['./color-field.component.scss'],
    standalone: false
})
export class ColorFieldComponent implements DynamicField, OnDestroy {
  @Output() valueChanged = new EventEmitter<DynamicField>();
  @Input() field: SchemaField;
  @Input() displayName: string;
  @Input() layerUId: string;
  @Input() set document(value: Document) {
    this.reader = new DocumentReader(value);
  }
  @Input() viewComponent: ViewComponent;
  @Input() schema: DocumentSchema;
  @Input() dataset: Dataset;
  reader: DocumentReader;
  showFieldAsEdit: boolean = false;
  isReadOnly: boolean;
  defaultColor = '#cccccc';
  colorValue: any;

  get value(): any {
    return this.colorValue;
  }
  set value(val: any) {
    this.colorValue = val;
  }

  get displayValue(): any {
    return this.value ?? this.defaultColor;
  }
  set displayValue(val: any) {
    this.value = val;
  }

  private _isEdit: boolean = false;
  @Input() set isEdit(edit: boolean) {
    this._isEdit = edit;

    this.calculateShouldDisplayFieldForEdit();
  }

  constructor() {}

  ngOnDestroy(): void {
    this.valueChanged.complete();
  }

  colorChanged(color: string) {
    this.value = color;

    this.onValueChanged();
  }

  onValueChanged(): void {
    this.valueChanged.emit(this);
  }

  calculateShouldDisplayFieldForEdit() {
    this.showFieldAsEdit = this._isEdit && !this.isReadOnly;
  }

  tpOnContentUpdated(): void {
    this.value = this.reader.getFieldValue(this.field.systemName);

    if ((this.field.fieldType & SystemFieldType.Editable) !== SystemFieldType.Editable || this.viewComponent?.configuration?.isReadOnly) {
      this.isReadOnly = true;
      this.calculateShouldDisplayFieldForEdit();
    }
  }
}
